const ManagementStatus = window.SIMPL.ManagementStatus;

export default function GetManagementStatus(type,no,dataKey) {
    // jsonが読み込めていない場合orjsonに定義されていない場合
    if(ManagementStatus == null || ManagementStatus.length <= 0) return null;

    // no/typeが未設定
    if(no === undefined || no === null || no === "") return null;
    if(type === undefined || type === null) return null;

    var typeDatas = ManagementStatus[type];
    var typeData = typeDatas.find(x => x.no === no);

    return typeData[dataKey];
}